import { QuestWithConfig, QuestSymbol } from 'state/vvsgotchi/models'

import { MoleDashGuide } from 'views/VvsGotchi/MoleDashGame/components/QuestDetailGuide'

import { AdoptGuide } from './Adopt'
import { TeamUpGuide } from './TeamUp'
import { BarterGuide } from './Barter'
import { MoleOpolyGuide } from './MoleOpoly'
import { HydrateGuide } from './Hydrate'
import { ProfitGuide } from './Profit'
import { SocialiseGuide } from './Socialise'
import { FarmGuide } from './Farm'
import { GoldDiggerGuide } from './GoldDigger'

const QuestDetailGuide = ({ quest }: { quest: QuestWithConfig }) => {
  switch (quest.symbol) {
    case QuestSymbol.ADOPT:
      return <AdoptGuide />
    case QuestSymbol.TEAM_UP:
      return <TeamUpGuide />
    case QuestSymbol.BARTER:
      return <BarterGuide />
    case QuestSymbol.MOLE_OPOLY:
      return <MoleOpolyGuide />
    case QuestSymbol.HYDRATE:
      return <HydrateGuide />
    case QuestSymbol.PROFIT:
      return <ProfitGuide />
    case QuestSymbol.SOCIALISE:
      return <SocialiseGuide />
    case QuestSymbol.FARM:
      return <FarmGuide />
    case QuestSymbol.GOLD_DIGGER:
      return <GoldDiggerGuide />
    case QuestSymbol.MOLE_DASH:
      return <MoleDashGuide />
    default:
      return null
  }
}

export default QuestDetailGuide
